import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListCheck } from '@fortawesome/free-solid-svg-icons';

import { internalControlsEnabled } from '../utils/permissions';
import type { BootstrapResponse } from '../api/bootstrap';

type Props = {
  bootstrap: BootstrapResponse | null;
  isCollapsedDesktop: boolean;
  onNavigate: () => void;
};

/**
 * Sidebar nav link for operator bulk remediation preview (internal build + role only).
 */
export function maybeRenderOperatorRemediationPreviewNav({
  bootstrap,
  isCollapsedDesktop,
  onNavigate,
}: Props): React.ReactNode {
  if (!internalControlsEnabled(bootstrap?.user?.role)) {
    return null;
  }

  return (
    <div data-testid="NAV_OPERATOR_REMEDIATION_PREVIEW">
      <NavLink
        to="/app/operator/remediation-preview"
        aria-label="Bulk remediation preview"
        title={isCollapsedDesktop ? 'Remediation preview' : undefined}
        onClick={onNavigate}
        className={({ isActive }) =>
          [
            'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors',
            isActive ? 'bg-accent-muted text-theme font-medium' : 'text-theme hover:bg-theme-tertiary',
            isCollapsedDesktop ? 'justify-center px-2' : '',
          ].join(' ')
        }
      >
        <FontAwesomeIcon icon={faListCheck} className="h-4 w-4 shrink-0" />
        {!isCollapsedDesktop ? <span>Remediation preview</span> : null}
      </NavLink>
    </div>
  );
}
